module.exports = __webpack_public_path__ + "img/bianzu2.a68755b3.png";